import { useBillingInfo } from "./useBillingInfo";
import { ScreeningProvider } from "../utils/screeningChecks";

/**
 * The tenant's screening provider, which decides which screening check types a
 * user may select when creating a record.
 *
 * It is a creation-time switch only and is never consulted when rendering an
 * existing record: a record renders according to the check it actually ran.
 *
 * Anything that is not exactly "LexisNexis2" resolves to "LexisNexis", so a
 * missing billing row, an unset value, WorldCheck and an unrecognised value all
 * fail safe to the legacy provider.
 *
 * `isLoading` must be respected by every consumer. Rendering the legacy list
 * while billing is in flight lets a LexisNexis2 user see and click a legacy
 * check before the correct list arrives.
 */
export const useScreeningProvider = () => {
  const { data, isLoading } = useBillingInfo();

  const raw = data?.data?.results?.[0]?.screening_provider;
  const provider: ScreeningProvider =
    raw === "LexisNexis2" ? "LexisNexis2" : "LexisNexis";

  return {
    provider,
    isLexisNexis2: provider === "LexisNexis2",
    isLoading,
  };
};
